export function CommonUser({ children }) {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-900">
      <div className="container mx-auto p-4">
        <div className="grid grid-cols-2 gap-4 items-center">
          <div>
            <h1 className="text-yellow-500 text-4xl mb-2">Eagle Aerospace</h1>
            <h2 className="text-gray-500 text-2xl">ADEW Support Portal</h2>
          </div>
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
}
